import { BuildingDef, BuildingType } from '../types';

export const BUILDING_DEFS: BuildingDef[] = [
  {
    type: BuildingType.Wall,
    name: 'Wall',
    woodCost: 3,
    coinCost: 0,
    solid: true,
    description: 'Blocks intruders!',
  },
  {
    type: BuildingType.House,
    name: 'House',
    woodCost: 5,
    coinCost: 5,
    solid: false,
    description: 'A cute little house.',
  },
];
